import React from "react";
import { Router, Route, Link, Switch } from "react-router-dom";

import "./index.less";
import { project } from "@/config.json";
import { inject, observer } from "mobx-react";
import { SessionStore, RouterStore, LocaleStore } from "@/stores/";

import Dashboard from "@/pages/Home/Dashboard";
import Spinner from "@/components/Spinner";
const About = React.lazy(() => import("@/pages/About"));
const CallCenter = React.lazy(() => import("@/pages/CallCenter"));
const FundManagement = React.lazy(() => import("@/pages/Home/FundManagement"));
const CreateAgent = React.lazy(() => import("@/pages/Home/CreateAgent"));
const Treasury = React.lazy(() => import("@/pages/Home/Treasury"));
const SubAccount = React.lazy(() => import("@/pages/Home/Dashboard/SubAccountPage"));
const AccountSettings = React.lazy(() => import("@/pages/Home/AccountSettings"));
const ReportForm = React.lazy(() => import("@/pages/Home/ReportForm"));
const MonthlyBill = React.lazy(() => import("@/pages/Home/ReportForm/MonthlyBill"));
const MinerWork = React.lazy(() => import("@/pages/Home/ReportForm/MinerWork"));
const Electricity = React.lazy(() => import("@/pages/Home/ReportForm/Electricity"));
const AgentManagement = React.lazy(() => import("@/pages/Home/AgentManagement"));
const ObserVerPanel = React.lazy(() => import("@/pages/ObserverPanel"));
const SubObserver = React.lazy(() => import("@/pages/ObserverPanel/SubObserver"));
const MainAccount = React.lazy(() => import("@/pages/Home/Dashboard/MainAccountPage"));
const AllRecords = React.lazy(() => import("@/pages/Home/Treasury/AllRecords"));
const MyInvestment = React.lazy(() => import("@/pages/Home/Treasury/MyInvestment"));

export interface HomeProps {
  session: SessionStore;
  router: RouterStore;
  locale: LocaleStore;
}

@inject("session", "router")
@observer
class Home extends React.Component<HomeProps, any> {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  state = {};

  render() {
    const { session, locale } = this.props;
    return (
      <section
        className={`home-${project}-container ${
          session.isWatcherTheme ? "observable-container" : ""
        }`}
      >
        <React.Suspense fallback={<Spinner />}>
          <Switch>
            <Route exact path="/createAgent" component={CreateAgent} />
            <Route exact path="/treasury/allrecords" component={AllRecords} />
            <Route exact path="/treasury/myinvestment" component={MyInvestment} />
            <Route exact path="/treasury" component={Treasury} />
            <Route exact path="/settings" component={AccountSettings} />
            <Route exact path="/fund" component={FundManagement} />
            {/* <Route exact path="/about" component={About} /> */}
            <Route exact path="/service" component={CallCenter} />
            <Route exact path="/account" component={SubAccount} />
            <Route exact path="/mainAccount" component={MainAccount} />
            <Route exact path="/report" component={ReportForm} />
            <Route exact path="/monthlyBill" component={MonthlyBill} />
            <Route exact path="/minerWork" component={MinerWork} />
            <Route exact path="/electricity" component={Electricity} />
            <Route exact path="/agentManagement" component={AgentManagement} />
            <Route exact path="/observer" component={ObserVerPanel} />
            <Route exact path="/observer/:id/detail" component={SubObserver} />
            <Route exact path="/subObserver" component={SubObserver} />
            <Route path="/" component={Dashboard} />
            <Route component={Dashboard} />
          </Switch>
        </React.Suspense>
        {/* <ZeroRateBall /> */}
      </section>
    );
  }
}

export default Home as React.ComponentClass;
